import { Button } from '#components/atoms/buttons/Button.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

type Props = {
  onAdd: () => void;
};

export function EmptyAdmins({ onAdd }: Props) {
  return (
    <CenteredLayout>
      <div>
        <h2 className="h3">No admins found</h2>
        <p className="p-lt mb-24">Admins can sign in and manage hosts, roles, and settings.</p>
        <Button onClick={onAdd}>Add admin</Button>
      </div>
    </CenteredLayout>
  );
}
